<template>
  <header class="fixed w-full bg-white/95 backdrop-blur-md z-50 border-b border-gray-100 shadow-sm">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="flex justify-between items-center h-16">
        <Logo />
        <Navigation class="hidden md:flex" :current-path="route.path" />
        <AuthButtons class="hidden md:flex" />
        <MobileMenuButton
          :is-open="isMenuOpen"
          @toggle="isMenuOpen = !isMenuOpen"
          class="md:hidden"
        />
      </div>
    </div>

    <MobileMenu
      v-if="isMenuOpen"
      @close="isMenuOpen = false"
      :current-path="route.path"
    />
  </header>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useRoute } from 'vue-router'
import Logo from './header/Logo.vue'
import Navigation from './header/Navigation.vue'
import AuthButtons from './header/AuthButtons.vue'
import MobileMenuButton from './header/MobileMenuButton.vue'
import MobileMenu from './header/MobileMenu.vue'

const route = useRoute()
const isMenuOpen = ref(false)
</script>
